import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { AuthenticationProviderType } from '@/domain/enums/authentication-provider-type';
import { GoogleButtonSize } from '@/domain/enums/google-button-size';
import { GoogleClient } from '@/infrastructure/clients/google/google-client';
import { Ref } from 'vue';
import { SocialIncentiveButtonsBase } from '../SocialIncentiveButtonsBase.class';

declare const GOOGLE_CLIENT_ID: string;

export default class GoogleSigninButton extends SocialIncentiveButtonsBase {
	public googleButtonElement: Ref<HTMLElement | null> = this.root;

	protected readonly buttonName = 'GoogleButton';

	constructor(
		store: IIncentiveV2Store,
		isRegistration: boolean,
		private template: string
	) {
		super(store, isRegistration);
		this.template = template;
	}

	public mounted(): void {
		super.mounted();

		if (!this.root.value) return;

		new GoogleClient(GOOGLE_CLIENT_ID)
			.renderGoogleButton(
				{ element: this.root.value, template: this.template, theme: "outline", gButtonSize: GoogleButtonSize.LARGE },
				null,
				this.signInWithGoogle.bind(this),
			)
			.catch(() => {
				this.store.mutations.setErrorMessage({
					message: "Google sign-in was not completed.",
					type: null,
				});
			});
	}

	public async signInWithGoogle(credential: string): Promise<void> {
		await this.signInWithProvider({
			provider: AuthenticationProviderType.GOOGLE,
			googleIdToken: credential,
		});
	}
}